import { WarningTooltipForAgGrid } from 'core/elements';
import { QuoteEntityType } from 'quotes/enums';
import { QuotePartHelper } from 'quotes/helpers';
import { IQuotePart } from 'quotes/types';

import { QuotePartColId } from './enums';

export const isRowSelectable = ({ data }) => !data.deleted;

export const getDefaultColDef = () => ({
  enableRowGroup: false,
  wrapHeaderText: true,
  autoHeaderHeight: true,
  minWidth: 100,
  maxWidth: 150,
  autoHeight: true,
  tooltipComponent: WarningTooltipForAgGrid,
});

export const aggFuncs = {
  sumQty: ({ values, rowNode: { rowGroupColumn } }) => {
    if (!rowGroupColumn) {
      return null;
    }

    const sum = values.reduce((acc: number, value: number) => acc + value, 0);

    return QuotePartColId.UOM === rowGroupColumn.getColId() ? sum : null;
  },
};

export const getRowClass = ({
  data: part,
  quoteEntityType = QuoteEntityType.QUOTE,
}: {
  data: IQuotePart;
  quoteEntityType?: QuoteEntityType;
}) => {
  const classes = [];

  if (!part) {
    return '';
  }

  if (part.deleted) {
    classes.push('deletedRow');
  }

  if (part?.noQuote || part?.substituted || part.deleted) {
    classes.push('disabledRow');
  }

  if (QuotePartHelper.isNotValid(part, quoteEntityType)) {
    classes.push('invalidRow');
  }

  return classes.join(' ');
};
